export const GET_FURNISHING_STATUS = '[Furnishing Status Action] Get Furnishing Status';
export const CONFIRMED_GET_FURNISHING_STATUS = '[Furnishing Status Action] Confirmed Get Furnishing Status';
